import { Client } from '@/services/API';

export function getClientNameFromID(clientList: Client[], id: string): string | undefined {
  const client = clientList.find((client) => client.id === id);
  return client ? client.clientName : undefined;
}
